import { desktopMenu } from "./DesktopHeaderMenu";
import { mobileMenu } from "./MobileHeaderMenu";

export const headerMenu = (
  viewName: any,
  isMobile: boolean,
  onItemClick: () => void,
) => {
  return isMobile ? mobileMenu(viewName, onItemClick) : desktopMenu(viewName);
};
